


function VideoCuenta() {


    return(
    <div className="card border-0 shadow-sm mt-4">
        <div className="card-body">
            <div className="ratio ratio-16x9 rounded overflow-hidden">
                <iframe
                    src="https://www.youtube.com/embed/NNkkp7fMTFE?rel=0"
                    title="Video explicativo de mi cuenta vendedor"
                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                />
            </div>
        </div>
    </div>
    )

}

export default VideoCuenta;